import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { URLS } from '../../../shared/constant/interface';
@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.less'],
})
export class TikTokChannelViewComponent implements OnInit {
  static SCENE = 'icc-msg-channel-view';
  record: any = {};
  constructor(public http: _HttpClient) {}
  provider = null;
  channel: any = {};

  ngOnInit() {
    const urlSel = URLS.searchChannelProvider.url;
    if (this.record.id > 0) {
      this.http.post(urlSel, this.record.msgType).subscribe(res => {
        res.data.forEach(res1 => {
          if (res1.id === this.record.providerId) {
            this.channel.providerName = res1.name;
            this.channel.identity = this.record.identity;
            this.channel.name = this.record.name;
            this.channel.appId = this.record.appId;
            this.channel.appKey = this.record.appKey;
            this.channel.appSecret = this.record.appSecret;
            this.channel.openId = this.record.openId;
            this.channel.accessToken = this.record.accessToken;
            this.channel.channelNum = this.record.channelNum;
            if (this.record.supportComment) {
              this.channel.supportComment = '是';
            } else {
              this.channel.supportComment = '否';
            }
          }
        });
      });
    }
  }
}
